import React from 'react';
import { Edit2, Save, X, Trash2 } from 'lucide-react';

const EditableSection = ({ title, isEditing, onEdit, onCancel, onSave, onRemove, children }) => {
  return (
    <div className="group relative mb-5">
      {title ? (
        <div className="flex justify-between items-baseline border-b-2 border-gray-800 mb-3 pb-1">
          <h2 className="text-lg font-bold text-gray-900 font-serif tracking-wide">
            {title}
          </h2>
          <div className="flex gap-2 items-center">
            {isEditing ? (
              <>
                <button onClick={onCancel} className="text-gray-600 hover:text-gray-900 flex items-center gap-1 text-xs font-sans font-medium">
                  <X size={14} /> Cancel
                </button>
                <button onClick={onSave} className="text-white bg-gray-800 hover:bg-black px-2 py-1 rounded flex items-center gap-1 text-xs font-sans font-medium transition-colors">
                  <Save size={14} /> Save
                </button>
              </>
            ) : (
              <>
                <button onClick={onEdit} className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-blue-600 hover:text-blue-800 flex items-center gap-1 text-xs font-sans font-medium">
                  <Edit2 size={14} /> Edit
                </button>
                {onRemove && (
                  <button 
                    onClick={onRemove} 
                    className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-red-500 hover:text-red-700 flex items-center gap-1 text-xs font-sans font-medium ml-1"
                    title="Remove Section"
                  >
                    <Trash2 size={14} /> Remove
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="absolute -right-2 top-0 transform translate-x-full">
            {isEditing ? (
              <div className="flex flex-col gap-2">
                <button onClick={onSave} className="text-white bg-gray-800 hover:bg-black p-1.5 rounded flex items-center justify-center transition-colors shadow-sm" title="Save">
                  <Save size={14} />
                </button>
                <button onClick={onCancel} className="text-gray-600 bg-gray-100 hover:bg-gray-200 p-1.5 rounded flex items-center justify-center transition-colors shadow-sm" title="Cancel">
                  <X size={14} />
                </button>
              </div>
            ) : (
              <button onClick={onEdit} className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-blue-600 hover:text-blue-800 p-1.5 rounded bg-blue-50 hover:bg-blue-100 shadow-sm" title="Edit">
                <Edit2 size={14} />
              </button>
            )}
        </div>
      )}
      <div className="font-serif text-gray-900">
        {children}
      </div>
    </div>
  );
};

export default EditableSection;
